


















import { Component, Vue, Emit } from 'vue-property-decorator';
import MessageDialog from '@/components/molecules/MessageDialog.vue';
import router from '@/router';
import { DialogType, PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    MessageDialog,
  },
})
export default class WarningOnAccessFromIosDialog extends Vue {
  private dialogType: DialogType = DialogType.Warning;

  private goHome(): void {
    router.push(PAGE_PATH_BY_NAME.portal);
  }

  @Emit('seen-the-ios-warning')
  private seenTheIosWarning() {
    return true;
  }
}
